import { __extends } from "tslib";
import { assign } from 'lodash-es';
import PropTypes from 'prop-types';
import { Component } from 'react';
var BodyStyle = /** @class */ (function (_super) {
    __extends(BodyStyle, _super);
    function BodyStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BodyStyle.prototype.componentDidMount = function () {
        this.setStyle();
    };
    BodyStyle.prototype.componentDidUpdate = function () {
        this.setStyle();
    };
    BodyStyle.prototype.setStyle = function () {
        assign(document.body.style, this.props.style);
    };
    BodyStyle.prototype.render = function () {
        return null;
    };
    return BodyStyle;
}(Component));
export default BodyStyle;
BodyStyle.propTypes = {
    style: PropTypes.object,
};
